import { put, call, takeLatest } from 'redux-saga/effects';
import { actions } from './Reducer';

import {
  getArtisanJobsSuccessAction,
  setArtisanJobsIsLoadingAction,
  createArtisanJobSuccessAction,
  updateArtisanJobSuccessAction,
  setArtisanJobsCountAction,
  getArtisanJobsPendingSuccessAction,
  deleteJobSuccessAction,
  getSingleArtisanJobSuccessAction,
  updateArtisanApplicantStatusSuccessAction
} from './Actions';
import {
  errorNotificationFromError,
  newSuccessNotificationAction
} from '../notifications/Actions';
import * as api from './Api';
import { push } from 'connected-react-router';

function* createArtisanJob({ payload }) {
  // if (payload.skills) payload.skills = payload.skills.split(',');
  payload.skills = payload.skills.map(skill => skill.value);

  try {
    yield put(setArtisanJobsIsLoadingAction(true));
    const response = yield call(api.createArtisanJob, payload);
    const { data } = response;
    const job = data;
    yield put(createArtisanJobSuccessAction(job));
    yield put(newSuccessNotificationAction(`Job Created `));

    if (payload.jobType === '1') yield put(push(`/artisan-jobs/pending`));
    else put(push(`/artisan-jobs/pending`));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setArtisanJobsIsLoadingAction(false));
  }
}

function* updateAtrisanJob({ payload: { id, formData } }) {
  formData.skills = formData.skills.map(skill => skill.value);
  try {
    yield put(setArtisanJobsIsLoadingAction(true));
    const response = yield call(api.updateArtisanJob, id, formData);
    const { data } = response;
    const updatedJob = data;
    yield put(updateArtisanJobSuccessAction(updatedJob));
    yield put(newSuccessNotificationAction(`Updated Job`));
    if (formData.jobType === '1') yield put(push(`/artisan-jobs/pending`));
    else put(push(`/artisan-jobs/pending`));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setArtisanJobsIsLoadingAction(false));
  }
}

function* getArtisanJobs({ payload }) {
  const defData = {
    offset: 0,
    size: 10,
    searchTerm: '',
    filterBy: [
      {
        jobType: '1'
      }
    ],
    filterArtisan: payload?.artisanId,
    filterArtisanCategory: '',

    sort: 'createdAt',
    dir: 'desc',
    profileId: payload?.artisanId
  };

  const body = { ...defData, ...payload };

  try {
    yield put(setArtisanJobsIsLoadingAction(true));
    const response = yield call(api.getArtisanJobs, body);
    const { data } = response;

    const count = data.count;
    const artisanJobs = data.content;

    yield put(setArtisanJobsCountAction(count));
    yield put(getArtisanJobsSuccessAction(artisanJobs));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setArtisanJobsIsLoadingAction(false));
  }
}

function* getSingleJob({ payload }) {
  try {
    yield put(setArtisanJobsIsLoadingAction(true));
    const response = yield call(api.getSingleArtisanJob, payload);
    const { data } = response;

    const artisanJob = data;

    yield put(getSingleArtisanJobSuccessAction(artisanJob));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setArtisanJobsIsLoadingAction(false));
  }
}

function* getArtisanPendingJobs({ payload }) {
  console.log(payload, 'payloadpayload');
  const defData = {
    offset: 0,
    size: 10,
    searchTerm: '',
    filterBy: [
      {
        jobType: '1'
      }
    ],
    filterArtisan: payload?.artisanId,
    filterArtisanCategory: '',
    sort: 'createdAt',
    dir: 'desc',
    profileId: payload?.artisanId
  };

  const body = { ...defData, ...payload };

  try {
    yield put(setArtisanJobsIsLoadingAction(true));
    const response = yield call(api.getArtisanPendingJobs, body);
    const { data } = response;

    const count = data.count;
    const artisanJobs = data.content;

    yield put(setArtisanJobsCountAction(count));
    yield put(getArtisanJobsPendingSuccessAction(artisanJobs));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setArtisanJobsIsLoadingAction(false));
  }
}

function* updateArtisanStatus({ payload }) {
  if (payload.skills) payload.skills = payload.skills.split(',');
  try {
    yield put(setArtisanJobsIsLoadingAction(true));
    const response = yield call(api.putUpdateApplicantStatus, payload);
    const { data } = response;

    yield put(updateArtisanApplicantStatusSuccessAction(data));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setArtisanJobsIsLoadingAction(false));
  }
}

function* deleteJob({ payload }) {
  try {
    yield put(setArtisanJobsIsLoadingAction(true));
    yield call(api.deleteArtisanJob, payload);

    yield put(deleteJobSuccessAction(payload));
    yield put(newSuccessNotificationAction('Job Deleted'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setArtisanJobsIsLoadingAction(false));
  }
}

export default function*() {
  yield takeLatest(actions.GET_JARTISAN, getArtisanJobs);
  yield takeLatest(actions.GET_JARTISAN_PENDING, getArtisanPendingJobs);
  yield takeLatest(actions.CREATE_JARTISAN, createArtisanJob);
  yield takeLatest(actions.UPDATE_JARTISAN, updateAtrisanJob);
  yield takeLatest(actions.DELETE_JARTISAN, deleteJob);
  yield takeLatest(actions.GET_SINGLE_JARTISAN, getSingleJob);
  yield takeLatest(
    actions.UPDATE_JARTISAN_APPLICANT_STATUS,
    updateArtisanStatus
  );
}
